import TextButton from "@components/buttons/TextButton"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body16MainStyles,
  h2Styles,
  h4Styles,
  smallcapsBold13Styles,
} from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

import Modal, { ModalBaseProps } from ".."

const Container = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  @media ${breakpoints.laptop} {
    height: 100%;
    margin-left: calc(1 / 12 * 100vw);
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.div`
  ${h4Styles}
  color: ${colors.black};

  @media ${breakpoints.laptop} {
    ${h2Styles}
    color: ${colors.black};
  }
`

const Subtitle = styled.div`
  ${body16MainStyles}
  color: ${colors.mediumDarkGray};
  margin-top: 31px;
  padding: 0 48px;
  text-align: center;

  @media ${breakpoints.laptop} {
    margin-top: 43px;
    padding: 0;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 48px;

  @media ${breakpoints.laptop} {
    padding: 0;
  }
`

const BackButton = styled(TextButton)`
  width: 100%;

  @media ${breakpoints.laptop} {
    width: 280px;
  }
`

const HomeButton = styled.button`
  cursor: pointer;
  ${smallcapsBold13Styles}
  background: none;
  border: none;
  outline: none;
  height: 48px;
  width: 100%;
  padding: 0;
  margin-top: 26px;

  @media ${breakpoints.laptop} {
    width: 280px;
    margin-top: 26px;
  }
`

interface ReviewSubmittedModalProps extends ModalBaseProps {}

const ReviewSubmittedModal = (props: ReviewSubmittedModalProps) => (
  <Modal {...props}>
    <Container>
      <Header>
        <Title>Thanks!</Title>
        <Subtitle>Your review will be posted on the site momentarily.</Subtitle>
      </Header>
      <Footer>
        <BackButton onClick={props.onRequestClose} text="Back to Product" />
        <Link to="/">
          <HomeButton>Home</HomeButton>
        </Link>
      </Footer>
    </Container>
  </Modal>
)

export default ReviewSubmittedModal
